import { SITE } from "@/config/site";

export const Logo = ({ size = "md" }) => {
  const heights = { md: "h-10 sm:h-11", lg: "h-16 sm:h-20" };
  return (
    <span className="inline-flex items-center rounded-xl bg-white px-3.5 py-2 shadow-md shadow-navy-dark/20">
      <img
        src="/logo.png"
        alt={`Logo ${SITE.name}`}
        className={`${heights[size]} w-auto`}
      />
    </span>
  );
};
